module.exports = __webpack_public_path__ + "img/welcome-overlay.96259ad2.png";